export {
  default as OpenPaymentsComponent,
  renderOpenPaymentsComponent,
} from './OpenPayments';
export * from './config';
